import { useEffect, useRef } from 'react'

import useScrollDepthAnalytic from 'src/hooks/useScrollDepthAnalytic'
import { pageScrollEvent } from 'src/lib/analytics'

import type { WithChildren } from 'src/types/utils'

interface PianoScrollAnalyticProps extends WithChildren {
  previousPageUrl?: string | null
}

const PianoScrollAnalytic = ({ children, previousPageUrl }: PianoScrollAnalyticProps) => {
  const previousUrl = useRef<string | null | undefined>(previousPageUrl)
  const handleScroll = (depth: number, pageTitle?: string) => {
    pageScrollEvent(depth, pageTitle, previousUrl.current)
  }
  useScrollDepthAnalytic([0.25, 0.5, 0.75, 0.9], handleScroll)
  useEffect(() => {
    previousUrl.current = previousPageUrl
  }, [previousPageUrl])
  return <>{children}</>
}

export default PianoScrollAnalytic
